// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

// CSS load order: Tailwind preflight FIRST, then Bootstrap (overrides preflight
// on legacy BootstrapVue screens), then the rest.
// See: discovery/lumen_web/css-load-order
import "./assets/css/tailwind.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "../node_modules/nprogress/nprogress.css";
import "vue-loading-overlay/dist/vue-loading.css";

import Vue from "vue";
import BootstrapVue from "bootstrap-vue";
import App from "./App";
import router from "./router";

import Loading from "vue-loading-overlay";

// Theme boot: apply saved preference before first paint.
// Default is light mode (no dark class).  Toggle is handled by
// ThemeToggle.vue in Slice 2; here we only restore a persisted state.
;(function () {
  var saved = localStorage.getItem('lumen.ui.theme')
  if (saved === 'dark') {
    document.documentElement.classList.add('dark')
  } else {
    document.documentElement.classList.remove('dark')
  }
})()

// Defensive migration: copy stray 'menus' key to 'menu' if present.
// Guards against copy-paste contamination from Stana (which had a menus/menu
// mismatch).  Lumen itself already uses 'menu' — this is belt-and-braces.
;(function () {
  var stray = localStorage.getItem('menus')
  var correct = localStorage.getItem('menu')
  if (stray && !correct) {
    localStorage.setItem('menu', stray)
    localStorage.removeItem('menus')
    console.info('[lumen] Migrated localStorage.menus → localStorage.menu')
  }
})()

Vue.use(BootstrapVue);
Vue.use(Loading);
Vue.config.productionTip = true;

Vue.mixin({
  data: function() {
    return {
      get urlAPI() {
        //return 'http://localhost:37400/v1';
        window.urlAPI = Vue.config.productionTip
          ? "https://api.nubetech.software/lumen/v1"
          : "http://127.0.0.1:37500/lumen_desa/v1";
        return Vue.config.productionTip
          ? "https://api.nubetech.software/lumen/v1"
          : "http://127.0.0.1:37500/lumen_desa/v1";
      }
    };
  }
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  template: "<App/>",
  components: { App }
});



// WEBPACK FOOTER //
// ./src/main.js